(function() {
  class OverflowHandler {
    constructor(section) {
      this.section = section;
      this.heroFrame = section.querySelector(".image__hero__frame");
      this.originalOverflowAttr = this.heroFrame?.getAttribute("data-overflow-background") || null;

      // Initial check
      this.applyRules();

      // Recheck on resize
      window.addEventListener("resize", () => this.applyRules());
    }

    applyRules() {
      if (!this.section) return;
      const width = window.innerWidth || document.documentElement.clientWidth;

      // Toggle class for desktop/mobile
      this.section.classList.toggle("js-overflow-container", width >= 768);

      // Toggle data-overflow-background on heroFrame
      if (this.heroFrame) {
        if (width < 768) {
          this.heroFrame.removeAttribute("data-overflow-background");
        } else if (this.originalOverflowAttr !== null) {
          this.heroFrame.setAttribute("data-overflow-background", this.originalOverflowAttr);
        }
      }
    }
  }

  // Polling in case section renders late
  function initOverflowHandler() {
    const sectionElement = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (sectionElement) {
      new OverflowHandler(sectionElement);
    } else {
      setTimeout(initOverflowHandler, 100);
    }
  }

  document.addEventListener("DOMContentLoaded", initOverflowHandler);
})();